/**
 * @param {string} name
 * @param {string} [line1]
 * @param {string} [line2]
 */
export function nameLine1(name, line1, line2) {
  if (line1) return line1.trim();
  if (!line2) return '';
  return name?.replace(line2, '').trim();
}
/**
 * @param {string} name
 * @param {string} [line1]
 * @param {string} [line2]
 */
export function nameLine2(name, line1, line2) {
  if (line2) return line2.trim();
  if (!line1) return name?.trim();
  if (name.startsWith(line1)) return name?.replace(line1, '').trim();
  return name?.trim();
}
